
type Props = {
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
    id?: string | number;
};

export function BatteryIcon({ width = 11, height = 6, className, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 11 6"
            fill="none"
            className={className}
            style={style}
        >
            <rect width="10" height="6" rx="1" fill="currentColor" fillOpacity="0.35"/>
            <rect width="8" height="6" fill="currentColor"/>
            <path d="M10 1.5C10.5523 1.5 11 1.94772 11 2.5V3.5C11 4.05228 10.5523 4.5 10 4.5V1.5Z" fill="currentColor" fillOpacity="0.35"/>
        </svg>
    );
}

export default BatteryIcon;